'use client';
import Carousel from '@/components/molecules/heroCarousel';
import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import SearchDropdown from './seachDropdown';
import VideoSection from './videoSection';
import SearchButton from './searchButton';
import UniversitySearchDropdown from './universitiesSearchDropdown';
import {
  useGetDegreeLevelsQuery,
  useGetMajorsQuery
} from '@/redux/api/majorApi';
import { getFormattedMajorsAndDegreeLevels } from '@/utils/helperFunctions';

const HeroSection = () => {
  const [filtersForm, setFiltersForm] = useState({
    universityId: '',
    university: '',
    studyLevel: '',
    major: ''
  });

  const handleChange = (name: string, value: string) => {
    setFiltersForm((prevState) => {
      if (name === 'university') {
        return {
          ...prevState,
          [name]: value,
          universityId: value, // Assuming this is needed based on your code
          studyLevel: '', // Reset program type
          major: '' // Reset specialization
        };
      }

      // For other field changes, just update that field
      return {
        ...prevState,
        [name]: value
      };
    });
  };

  const {
    data: majorsPrograms,
    isLoading: isLoadingMajors,
    isFetching: isFetchingMajors
  } = useGetMajorsQuery({
    university_id: filtersForm?.universityId
  });

  const {
    data: degreeLevelsPrograms,
    isLoading: isLoadingDegreeLevels,
    isFetching: isFetchingDegreeLevels
  } = useGetDegreeLevelsQuery({
    university_id: filtersForm?.universityId
  });

  const programsTypes = {
    id: 2,
    title: 'Program Type',
    name: 'studyLevel'
  };
  const programSpecializations = {
    id: 3,
    name: 'major',
    title: 'Specialization'
  };

  return (
    <Box pb={2.5}>
      <Box sx={styles.coverImage}>
        <Carousel />
      </Box>
      <Box position="relative">
        <Container sx={styles.container}>
          <Paper sx={styles.searchCard}>
            <Typography variant="h6">Search For Admission Here</Typography>
            <Grid container spacing={2} my={2}>
              <Grid size={{ xs: 12, sm: 4 }}>
                <UniversitySearchDropdown
                  onChange={handleChange}
                  title="Select University"
                  name="university"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <SearchDropdown
                  isLoading={isFetchingDegreeLevels || isLoadingDegreeLevels}
                  onChange={handleChange}
                  item={programsTypes}
                  options={
                    isFetchingDegreeLevels || isLoadingDegreeLevels
                      ? []
                      : getFormattedMajorsAndDegreeLevels(degreeLevelsPrograms)
                  }
                  value={filtersForm.studyLevel}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <SearchDropdown
                  isLoading={isFetchingMajors || isLoadingMajors}
                  onChange={handleChange}
                  item={programSpecializations}
                  options={
                    isFetchingMajors || isLoadingMajors
                      ? []
                      : getFormattedMajorsAndDegreeLevels(majorsPrograms)
                  }
                  value={filtersForm.major}
                />
              </Grid>
            </Grid>
            <SearchButton filtersForm={filtersForm} />
          </Paper>
        </Container>
        <Container>
          <VideoSection />
        </Container>
      </Box>
    </Box>
  );
};

export default HeroSection;

const styles = {
  coverImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    pt: { xs: 10, md: 15, lg: 20 }
  },
  titleContainer: {
    maxWidth: 900
  },
  searchCard: {
    p: 3,
    borderRadius: 3,
    boxShadow: '0px 4px 34px 0px rgba(37, 37, 37, 0.05);',
    textAlign: 'center',
    maxWidth: 1150,
    width: '100%',
    mt: 40
  }
};
